import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson8: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.88rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between text-[1.56rem]">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson7"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Stoicism</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson9"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[7.56rem] text-justify text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[7.56rem] text-[1.56rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>Importance of Stoicism?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Stoicism is based on ideas that help people to live their best
                  possible lives. It’s a philosophy that promotes positive
                  emotions and helping individuals embrace the virtues of their
                  character. It does this by highlighting the importance of
                  simplicity so that people can find peace and harmony within
                  themselves and the world around them and focus on what truly
                  matters rather than getting caught up in negative emotions and
                  behaviours.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0 text-[1.88rem]">
              <span>
                <b>The Four Stoic Virtues</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Wisdom</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Courage</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>{`Temperance `}</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Justice</span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[30.44rem] h-[40.56rem] object-cover"
            alt=""
            src="/10@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Wisdom</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                “The chief task in life is simply this: to identify and separate
                matters so that I can say clearly to myself which are externals
                not under my control, and which have to do with the choices I
                actually control. Where then do I look for good and evil? Not to
                uncontrollable externals, but within myself to the choices that
                are my own” — Epictetus
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It’s the meaning of philosophy: a love of wisdom. In Diogenes
                Laërtius’ Lives of the Eminent Philosophers, he wrote of the
                Stoics, “wisdom they define as the knowledge of things good and
                evil and of what is neither good nor evil…knowledge of what we
                ought to choose, what we ought to beware of, and what is
                indifferent.”
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Following having this knowledge, wisdom ultimately informs
                action. Viktor Frankl said, “Between stimulus and response there
                is a space. In that space is our power to choose our response.”
                In that space is wisdom’s opportunity. Recognizing that space is
                the first step. That space is where we either take the lessons
                from our reading and apply it or we throw it out the window and
                act impulsively and irrationally.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Wisdom is harnessing what the philosophy teaches then wielding
                it in the real world. As Seneca put it, “Works not words.”
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Courage</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Epictetus was once asked which words would help a person thrive.
                “Two words should be committed to memory and obeyed,” he said,
                “persist and resist.”
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>{`It is the timeless symbol of Stoicism, the lone knight fighting a war they cannot hope to win, but fighting bravely and honourably nonetheless. `}</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Each fight, even if somewhat futile, required enormous amounts
                of courage. Each required resisting the comfort of the status
                quo and coming to one’s own judgment.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Marcus Aurelius could have lost himself in oblivion and power,
                but instead fought a lifelong battle against himself, within
                himself, to improve and help others.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                That’s Stoic courage. Courage to face misfortune. Courage to
                face death. Courage to risk yourself for the sake of your fellow
                man. Courage to hold to your principles, even when others get
                away with or are rewarded for disregarding theirs. Courage to
                speak your mind and insist on truth.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]  inline-block h-[116.88rem] shrink-0 text-[0.83rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>How To Eat, Drink, And Exercise Like A Stoic</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <span>
                <b>Food:</b>
                <span>
                  {" "}
                  sum up the question of food, I maintain that its purpose
                  should be to produce health and strength, that one should for
                  that purpose eat only that which requires no great outlay, and
                  finally that at table one should have regard for a fitting
                  decorum and moderation, and most of all should be superior to
                  the common vices of filth and greedy haste.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Recommended culinary simplicity through the “natural”
                nourishment of plants and grains rather than animals. He also
                explicitly mentioned fruits and vegetables that do not require
                much cooking, as well as cheese, milk, and honey.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Although the Stoics weren’t strictly vegetarian, they wouldn’t
                have eaten much meat in general — Musonius viewed it as a “heavy
                food” that was an obstacle to thinking and reasoning.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">
                  <span className="text-[1.51rem]">Acceptable Eating:</span>
                </b>
                <span>
                  <b className="font-dm-sans">{` `}</b>
                  <span>
                    For the sake of our health, the Stoics argued, we should
                    avoid overeating. “By overloading the body with food,” wrote
                    Seneca. “You strangle the soul and render it less active.”
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Musonius Rufus also regarded the following eating habits as
                  mistakes:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Eating in too much of a hurry</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Overdressing food with pickles and sauces</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Preferring sweeter foods to more nutritious ones</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Not serving food of the same kind or amount to one’s guests
                    as to oneself
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    To avoid making these mistakes, his advice was to accustom
                    oneself through constant practice to choosing food not for
                    enjoyment but for nourishment, “not to tickle one’s palate
                    but to strengthen one’s body”.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">
                  <span className="text-[.51rem]">Exercises:</span>
                </b>
                <span>
                  <b className="font-dm-sans">{` `}</b>
                  <span>
                    There are short and simple exercises which tire the body
                    rapidly, and so save our time; and time is something of
                    which we ought to keep strict account. These exercises are
                    running, brandishing weights, and jumping. Select for
                    practice any one of these, and you will find it plain and
                    easy. But whatever you do, come back soon from body to mind.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  It’s common to think of ancient philosophers as merely
                  thinkers; stationary souls who spent most of their time
                  sitting and pondering, but the fact is the Stoics worked out.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Appropriately fueled by their diet, they exercised enough to
                  improve their fitness and keep the body functioning well.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Just like their approach to eating, however, they applied
                  moderation to exercise and were careful not to overindulge
                  lest they neglect their philosophical pursuits.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  The importance the Stoics gave to exercise can also be seen in
                  the various instances where they draw parallels between the
                  art of living and athletics. Epictetus, for example, did this
                  often:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>{`First of all, condemn your own actions, and then, after having condemned them, don’t give up on yourself … You should learn instead from what the wrestling masters do. The boy has taken a fall: ‘Get up,’ he says, ‘and resume the fight until you grow strong.’ Epictetus, `}</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="text-[.51rem] font-dm-sans">{`Taking Walks:  `}</b>
                <span>
                  We ought to take outdoor walks, to refresh and raise our
                  spirits by deep breathing in the open air. As a means of
                  refreshing and resetting the mind, it’s hard to argue that a
                  simple stroll is any less valuable today than it was to the
                  Stoics two thousand years ago.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>{`You have to submit to discipline, maintain a strict diet, abstain from rich foods, exercise under compulsion at set times in weather hot and cold, refrain from drinking water or wine whenever you want — in short, you have to hand yourself over to your trainer as if he were your doctor. `}</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>{` `}</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
        </div>
        <div className="flex flex-row items-center justify-center gap-[7.56rem]">
          <img
            className="relative w-[31.56rem] h-[22.81rem] object-cover"
            alt=""
            src="/11@2x.png"
          />
          <img
            className="relative w-[31.56rem] h-[22.81rem] object-cover"
            alt=""
            src="/12@2x.png"
          />
        </div>
        <div className="flex flex-row items-center justify-center gap-[7.56rem]">
          <img
            className="relative w-[31.56rem] h-[22.81rem] object-cover"
            alt=""
            src="/13@2x.png"
          />
          <img
            className="relative w-[31.56rem] h-[23rem] object-cover"
            alt=""
            src="/14@2x.png"
          />
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson9"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson8;
